module.exports = __webpack_public_path__ + "static/images/bell-notification-small.8c40b7978b840848df704757cab1dfc4.svg";